module.exports = new function showReel ()
{

        var playShowreel = $('.js-play-showreel');
        var showreelScreen = $('.showreel-lb');
        var showreelVideo = $('#showreel-video');
        var closeShowreel = $('.close-showreel');
        var vimeoHolder = $('.vimeo-holder');

        var playVideo = function() {
            showreelVideo[0].play();
        };

        var stopVideo = function() {
            showreelVideo[0].pause();
            showreelVideo[0].currentTime = 0;
        };

        $(document).keyup(function(e) {
            if ( e.keyCode === 27 )
            {
                showreelScreen.removeClass('showreel-lb_show');
                vimeoClose();
                stopVideo();
            }
        });

        var vimeoPlay = function() {
            var vimeoUrl = $('.vimeo-holder').data('vimeo');
            vimeoHolder.append('<iframe src="https://player.vimeo.com/video/'+ vimeoUrl +'?title=0&autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
        };

        var vimeoClose = function() {
            vimeoHolder.empty();
        };

        closeShowreel.on('click', function() {
            showreelScreen.removeClass('showreel-lb_show');
            vimeoClose();
            stopVideo();
        });

        playShowreel.on('click', function() {
            showreelScreen.addClass('showreel-lb_show');
            $(this).hasClass('vimeo-btn') ? vimeoPlay() : 'nothing';
            playVideo();
        });

};
